import { getRequest, postRequest, putRequest, patchRequest } from "../../shared/api/axiosHandler";

export const getCustomer = async () => {
    try {
      return await getRequest("/api/v1/customer", {}, true);
    
    } catch (error) {
      throw error;
    }
  };

export const updateCustomer = async (customer) => {
    try {
        return await putRequest("/api/v1/customer/profile", customer, true);
    } catch (error) {
        throw error;
    }
};

export const addNewAddress = async (address) => {
    try {
        return await postRequest("/api/v1/address", address, true);
    } catch (error) {
        throw error;
    }
};

export const getAddresses = async () => {
    try {
        return await getRequest("/api/v1/address", {}, true);
    } catch (error) {
        throw error;
    }
};

export const updateAddress = async (address) => {
    try {
        return await patchRequest("/api/v1/address", address, true);
    } catch (error) {
        throw error;
    }
};

export const disableAddress = async (addressId) => {
    try {
        return await patchRequest(`/api/v1/address/disable/${addressId}`, {}, true);
    } catch (error) {
        throw error;
    }
};
